module.exports = __webpack_public_path__ + "c349a51068148206d7ce7be9ea688d4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/anniversary/images/share.jpg
// module id = 2
// module chunks = 0 1 2 3 4